
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transactions/messages",
      function () {
        return require("private-next-pages/transactions/messages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transactions/messages"])
      });
    }
  